<!--
 * @Author: your name
 * @Date: 2021-04-30 13:08:08
 * @LastEditTime: 2021-05-07 10:00:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Wjb-Website\src\App.vue
-->
<template>
  <div id="app">
    <keep-alive :include="includeList" :max="10">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      includeList: this.$store.state.common.includeList,
    };
  },

  methods: {},

  created() {},
};
</script>

<style lang='less' scoped>
</style>

